module.exports = __webpack_public_path__ + "static/scale-model-of-akron-art-museum-in-akron-ohio-fc0b4c57ab15cb634da3cbf80f6eb4ee.png";